import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Cruzeiro Ria Formosa e Tavira a partir de Vilamoura · Morningstar";
const DESC = "Cruzeiro privado de dia inteiro a partir de Vilamoura para as ilhas-barreira da Ria Formosa — Farol, Armona, Culatra — uma das 7 Maravilhas Naturais de Portugal. Almoço a bordo ou em terra.";
const PATH = "/pt/cruzeiro-ria-formosa-tavira";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/cruzeiro-ria-formosa-tavira")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Ria Formosa e Tavira · Partida de Vilamoura · Algarve",
        title: "Cruzeiro Ria Formosa e Tavira a partir de Vilamoura no ",
        titleAccent: "Morningstar.",
        sub: "Um dia completo privado a leste — ilhas-barreira douradas, Atlântico calmo e almoço no Farol ou na Armona. Até 18 pessoas, bar incluído.",
        ctaPrimary: "Ver dias completos",
        ctaSecondary: "Planear o meu dia",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "ria formosa passeio barco, ria formosa vilamoura, ilha do farol cruzeiro, tavira passeio barco, algarve leste cruzeiro",
      altPath: { en: "/ria-formosa-tavira-cruise", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Ria Formosa & Tavira Cruise from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Cruzeiro Ria Formosa e Tavira", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});
